export default "__VITE_ASSET__DSChhGro__"